import { render, staticRenderFns } from "./check-identity.vue?vue&type=template&id=a8ee23a0&scoped=true&"
import script from "./check-identity.vue?vue&type=script&lang=js&"
export * from "./check-identity.vue?vue&type=script&lang=js&"
import style0 from "./check-identity.vue?vue&type=style&index=0&id=a8ee23a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ee23a0",
  null
  
)

export default component.exports